module.exports = __webpack_public_path__ + "img/maid_cleaning_new3.9814e694.png";